import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-martini",
  "use": "icon-th-martini-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-martini\">\n<path d=\"M29.7075 5.7075C29.8475 5.56764 29.9429 5.38939 29.9815 5.19531C30.0202 5.00122 30.0004 4.80003 29.9246 4.61721C29.8489 4.43439 29.7206 4.27815 29.556 4.16828C29.3914 4.05841 29.1979 3.99984 29 4H2.99999C2.8021 3.99984 2.60861 4.05841 2.44401 4.16828C2.27942 4.27815 2.15112 4.43439 2.07537 4.61721C1.99962 4.80003 1.97981 5.00122 2.01846 5.19531C2.05712 5.38939 2.15248 5.56764 2.29249 5.7075L15 18.4137V26H11C10.7348 26 10.4804 26.1054 10.2929 26.2929C10.1054 26.4804 9.99999 26.7348 9.99999 27C9.99999 27.2652 10.1054 27.5196 10.2929 27.7071C10.4804 27.8946 10.7348 28 11 28H21C21.2652 28 21.5196 27.8946 21.7071 27.7071C21.8946 27.5196 22 27.2652 22 27C22 26.7348 21.8946 26.4804 21.7071 26.2929C21.5196 26.1054 21.2652 26 21 26H17V18.4137L29.7075 5.7075ZM5.41374 6H26.5862L24.5862 8H7.41374L5.41374 6ZM16 16.5863L9.41374 10H22.5862L16 16.5863Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-martini.svg
// module id = ISJg
// module chunks = 83